import { Grid } from '@mui/material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';
import { SessionContext, SessionContextType } from '../../../contexts/session';
import { PollRecord } from '../../../models/Poll';
import { MIN_VOTES_TO_DISPLAY } from '../Poll';
import CommentsButton from './CommentsButton/CommentsButton';
import PollOptionsButton from './PollOptionsButton/PollOptionsButton';
import PollVotes from './PollVotes/PollVotes';
import SharePoll from './SharePoll/SharePoll';

interface PollExtrasProps {
    poll: PollRecord;
    mypoll?: boolean;
    bottomComponent?: JSX.Element;
    showComments: boolean;
    setShowComments: React.Dispatch<React.SetStateAction<boolean>>;
}

const PollExtras = (props: PollExtrasProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const navigate = useNavigate();
    const totalVotes =
        props.poll.options[0].votes + props.poll.options[1].votes;

    const onClickHandler = () => {
        if (session.user || anonUser.user) {
            props.setShowComments(!props.showComments);
        } else {
            navigate('/auth/sign-in');
        }
    };

    return (
        <>
            <Grid container spacing={1} className='poll-extras'>
                <Grid item xs={6}>
                    {/* HP2 */}
                    {totalVotes >= MIN_VOTES_TO_DISPLAY && (
                        <PollVotes votes={totalVotes} />
                    )}
                </Grid>
                <Grid item xs={6} className='align-right'>
                    <SharePoll poll={props.poll} />
                    <CommentsButton
                        count={props.poll.comments}
                        onClickHandler={onClickHandler}
                    />
                    <PollOptionsButton poll={props.poll} />
                </Grid>
            </Grid>
            {props.bottomComponent}
        </>
    );
};

export default PollExtras;
